"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OWN_PROPS = exports.MASK_PROPS = void 0;
const MASK_PROPS = exports.MASK_PROPS = ['autofix', 'blocks', 'commit', 'definitions', 'format', 'lazy', 'mapToRadix', 'mask', 'max', 'min', 'normalizeZeros', 'overwrite', 'padFractionalZeros', 'parse', 'pattern', 'placeholderChar', 'prepare', 'radix', 'scale', 'signed', 'thousandsSeparator', 'validate'];
const OWN_PROPS = exports.OWN_PROPS = ['value', 'type', 'onAccept', 'onComplete'];